@switch (appearance) {
  @case ('spinner') {
    <img
      [src]="'/assets/icons/animated/' + (theme.isDarkMode ? 'loading-transparent-darkmode.gif' : 'loading-transparent.gif')"
      class="loading"
    />
  }
  @case ('pulse') {
    <div class="pulse">
      <span style="--loading-pulse-delay:0;"></span>
      <span style="--loading-pulse-delay:1;"></span>
    </div>
  }
}
